<h2 class="page-header">
  <ng-container
    *ngIf="signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_TITLE_ADJUSTMENT"
  >
    Titels
  </ng-container>
  <ng-container
    *ngIf="
      signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_PHONE_NUMBER_ADJUSTMENT
    "
  >
    Telefoonnummers
  </ng-container>
  <ng-container
    *ngIf="signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_STICKER"
  >
    Stickers
  </ng-container>
</h2>

<ng-container *ngIf="loading">
  <div class="table-loader-overlay table-overlay-margin">
    <div class="overlay-spinner-container">
      <mat-spinner color="primary" diameter="75"></mat-spinner>
    </div>
  </div>
</ng-container>

<div matSort class="flex-table upper-space">
  <div class="flex-header-row">
    <div class="flex-3 flex-table-cell">
      Bedrijf
      <filter-input
        [filterObject]="
          getFilterForKey('sign__participatingCompanies__company__regularName')
        "
        [isDate]="false"
        (click)="$event.preventDefault() && $event.stopPropagation()"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
      ></filter-input>
    </div>
    <ng-container
      *ngIf="
        signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_TITLE_ADJUSTMENT
      "
    >
      <div class="flex-3 flex-table-cell">
        Titel
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        signAssociationType ===
        SIGN_ASSOCIATION_TYPE.SIGN_PHONE_NUMBER_ADJUSTMENT
      "
    >
      <div class="flex-3 flex-table-cell">
        Telefoonnummer
      </div>
    </ng-container>
    <ng-container
      *ngIf="signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_STICKER"
    >
      <div class="flex-3 flex-table-cell">
        Sticker
      </div>
    </ng-container>
    <div class="flex-3 flex-table-cell">
      Bord
    </div>
    <div class="flex-2 flex-table-cell">
      Stand./cust.
    </div>
    <div class="flex-1-25 flex-table-cell" mat-sort-header="height">
      Hoogte
    </div>
    <div class="flex-1 flex-table-cell"></div>
    <div class="flex-2 flex-table-cell" mat-sort-header="width">Breedte</div>
    <div class="flex-3 flex-table-cell">Tekst</div>
    <div class="flex-3 flex-table-cell">Fond</div>
    <div class="flex-2 flex-table-cell">Ontwerp</div>
    <div class="flex-1 flex-table-cell">Voorraad</div>
    <div class="flex-1-5 flex-table-cell">
      Grafisch
      <filter-not-true-boolean
        [filterObject]="getFilterForKey('graphicsComplete')"
        (toggleFilterEmitter)="toggleFilter($event)"
      ></filter-not-true-boolean>
    </div>
    <div class="flex-1 flex-table-cell">
      Admin
      <filter-not-true-boolean
        [filterObject]="getFilterForKey('adminComplete')"
        (toggleFilterEmitter)="toggleFilter($event)"
      ></filter-not-true-boolean>
    </div>
    <div class="flex-2 flex-table-cell"></div>
  </div>
  <div *ngFor="let item of associationObjects" class="flex-table-row">
    <div class="flex-3 flex-table-cell companies-label">
      {{ item.companiesDisplay }}
    </div>
    <ng-container
      *ngIf="
        signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_TITLE_ADJUSTMENT
      "
    >
      <div class="flex-3 flex-table-cell" matTooltip="{{ item.title }}">
        {{ item.title | shortenText: 30 }}
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        signAssociationType ===
        SIGN_ASSOCIATION_TYPE.SIGN_PHONE_NUMBER_ADJUSTMENT
      "
    >
      <div class="flex-3 flex-table-cell" matTooltip="{{ item.title }}">
        {{ item.phoneNumber | shortenText: 30 }}
      </div>
    </ng-container>
    <ng-container
      *ngIf="signAssociationType === SIGN_ASSOCIATION_TYPE.SIGN_STICKER"
    >
      <div class="flex-3 flex-table-cell" matTooltip="{{ item.title }}">
        {{ item.text | shortenText: 30 }}
      </div>
    </ng-container>
    <div class="flex-3">
      <span
        *ngIf="item.sign != null"
        class="click-link"
        [routerLink]="['/signs-portal/signs', item.sign.id]"
        >{{ item.sign.title }}</span
      >
    </div>
    <div class="flex-2 flex-table-cell">
      {{ item.standard | formatBoolean: false:'Standaard':'Custom' }}
    </div>
    <div class="flex-1-25 flex-table-cell">{{ item.height | or }} cm H</div>
    <div class="flex-1 flex-table-cell center">x</div>
    <div class="flex-2 flex-table-cell">{{ item.width | or }} cm B</div>
    <div class="flex-3 flex-table-cell">
      {{ item.textColor }}
    </div>
    <div class="flex-3 flex-table-cell">
      {{ item.foundationColor }}
    </div>
    <div class="flex-2 flex-table-cell">
      <ng-container *ngIf="item.examples?.length > 0">
        <img
          [ngClass]="first ? '' : 'hidden'"
          width="30px"
          height="30px"
          [src]="'/api/assets/' + item.examples[0].asset.uuid + '/30'"
          (click)="openLightbox(item.examples)"
        />
      </ng-container>
    </div>
    <div class="flex-1 flex-table-cell">
      {{ item.inStock | formatBoolean: false }}
    </div>
    <div class="flex-1-5 flex-table-cell">
      <mat-icon
        *ngIf="item.graphicsComplete"
        class="fa-2x check-color graphics-complete-translate"
        >check</mat-icon
      >
      <mat-icon
        *ngIf="!item.graphicsComplete"
        class="fa-2x warning-color graphics-complete-translate"
        >report_problem</mat-icon
      >
    </div>
    <div class="flex-1 flex-table-cell">
      <mat-icon
        *ngIf="item.adminComplete"
        class="fa-2x check-color graphics-complete-translate"
        >check</mat-icon
      >
      <mat-icon
        *ngIf="!item.adminComplete"
        class="fa-2x warning-color graphics-complete-translate"
        >report_problem</mat-icon
      >
    </div>
    <div class="flex-table-cell flex-2">
      <div class="d-flex">
        <mat-icon
          svgIcon="edit"
          class="clickable"
          (click)="editItem(item)"
        ></mat-icon>
        <mat-icon
          svgIcon="close"
          class="left-space clickable"
          (click)="deleteItem(item)"
        ></mat-icon>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="
    associationObjects === EMPTY_OBJECT ||
    associationObjects == null ||
    associationObjects.length === 0
  "
  class="no-result-text"
>
  <div>Geen resultaten gevonden</div>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
